import { createContext } from "react";

const ModalContext = createContext({
  visible: false,
  title: null,
  body: null,
  backdrop: true,
  large: false,
  timestamp: Date.now(),
  hideModal: () => {},
  showModal: (_title, _body) => {},
  showLargeModal: (_title, _body) => {},
  showStaticModal: (_title, _body) => {},
  showLargeStaticModal: (_title, _body) => {},
  updateModalTitle: (_title) => {},
  updateModalBody: (_body) => {},
});

export default ModalContext;
